import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { HttpStatus, Redirect } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// types
import { AvailableLanguages, ContextProps } from '../types/types'

// pats
import Paths from './paths'

// components
import AuthRoute from './AuthRoute'
import HomePageRoute from './HomePageRoute'
import SalonRoute from './SalonRoute'
import SalonsListRoute from './SalonsListRoute'
import SalonsCategoryRoute from './SalonsCategoryRoute'
import MyReservationsRoute from './MyReservationsRoute'
import MyPassesRoute from './MyPassesRoute'
import MyPassRoute from './MyPassRoute'
import AuthCompletePage from '../pages/AuthComplete/AuthCompletePage'
import MyReservationRoute from './MyReservationRoute'
import SalonsCategoryDeprecatedRoute from './deprecated/SalonsCategoryDeprecatedRoute'
import HomePageDeprecatedRoute from './deprecated/HomePageDeprecatedRoute'

// utils
import { AVAILABLE_LANGUAGES } from '../appDefaults'
import { DeprecatedPaths } from './deprecatedPaths'

const AppRoutes: React.FC<React.PropsWithChildren<ContextProps>> = (props) => {
	const { locale } = useIntl() as { locale: AvailableLanguages }

	// if header included unsupported language, return null
	if (!AVAILABLE_LANGUAGES.includes(locale)) {
		return null
	}

	return (
		<Routes>
			{/* redirect */}
			<Route path='/' element={<Redirect to={Paths[locale]['/salons']} />} />

			{/* home page */}
			<Route path={Paths[locale]['/salons']} element={<HomePageRoute {...props} />} />

			{/* salons list */}
			<Route path={Paths[locale]['/salons/all']} element={<SalonsListRoute {...props} />} />
			<Route path={Paths[locale]['/salons/all/:categorySlug']} element={<SalonsCategoryRoute {...props} />} />
			<Route path={Paths[locale]['/salons/all/:categorySlug/:citySlug']} element={<SalonsCategoryRoute {...props} />} />

			{/* salon detail */}
			<Route path={Paths[locale]['/salons/:salonSlug']} element={<SalonRoute {...props} />} />

			{/* my reservations */}
			<Route element={<AuthRoute />}>
				<Route path={Paths[locale]['/salons/my-reservations']} element={<MyReservationsRoute {...props} />} />
			</Route>
			<Route path={Paths[locale]['/salons/my-reservations/:reservationID']} element={<MyReservationRoute {...props} />} />

			{/* my passes */}
			<Route element={<AuthRoute />}>
				<Route path={Paths[locale]['/salons/passes']} element={<MyPassesRoute {...props} />} />
				<Route path={Paths[locale]['/salons/passes/:passID']} element={<MyPassRoute {...props} />} />
			</Route>

			{/* auth complete - handle redirects from Notino IDP */}
			<Route element={<AuthRoute />}>
				<Route path={Paths[locale]['/salons/auth-complete']} element={<AuthCompletePage {...props} />} />
			</Route>

			{/* Deprecated routes */}
			{DeprecatedPaths[locale]['/salons/homepage'] && <Route path={DeprecatedPaths[locale]['/salons/homepage']} element={<HomePageDeprecatedRoute />} />}
			{DeprecatedPaths[locale]['/salons/services/:categorySlug'] && (
				<Route path={DeprecatedPaths[locale]['/salons/services/:categorySlug']} element={<SalonsCategoryDeprecatedRoute />} />
			)}

			<Route
				path={'*'}
				element={
					<HttpStatus status={404} {...props}>
						{null}
					</HttpStatus>
				}
			/>
		</Routes>
	)
}

export default AppRoutes
